import React from 'react';
import SalesBarChart from './SalesBarCharts';
import CircleBarChart from './invoicesChart';
import MostSoldProducts from './MostSoldProducts';
import SalesData from './SalesData';
import MonthlyProfitChart from './MonthlyProfileChart';
import SoldProductCategory from './SoldProductCategory';

function Dashboard() {
  return (
    <div
      style={{
        width: '1782px',
        height: '740px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '40px',
        marginTop: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
      }}
    >
      {/* First row of charts */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: '35%',
            height: '320px',
            marginTop: '20px',
            marginLeft: '25px',
            background: '#FFFFFF',
            border: '1px solid #EBEAF2',
            boxShadow: '0px 2px 8px rgba(6, 12, 34, 0.0392157)',
            borderRadius: '40px',
            padding: '10px',
          }}
        >
          <MonthlyProfitChart />
        </div>
        <div style={{
     
       marginTop:'20px',
      //  borderRadius: '40px',
      //     marginRight:'15px',
      //     background: '#FFFFFF',
      //     border: '1px solid #EBEAF2',
      //     boxShadow: '0px 2px 8px rgba(6, 12, 34, 0.0392157)',
        }}>
          <SoldProductCategory />
        </div>
        <div
          style={{
            width: '35%',
            maxWidth: '620px',
            height: '320px',
            marginTop: '28px',
            marginRight: '40px',
            background: '#FFFFFF',
            border: '1px solid #EBEAF2',
            boxShadow: '0px 2px 8px rgba(6, 12, 34, 0.0392157)',
            borderRadius: '40px',
            padding: '10px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <CircleBarChart />
        </div>
      </div>
      {/* second row start  */}
      <div
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >

        <div
          style={{
            width: '35%',
            height: '300px',
            marginTop: '30px',
            marginLeft: '20px',
            // padding: '20px',
            
            background: '#FFFFFF',
            border: '1px solid #EBEAF2',
            boxShadow: '0px 2px 8px rgba(6, 12, 34, 0.0392157)',
            borderRadius: '40px',
          }}
        >
          <SalesBarChart />
        </div>


        <div
          style={{
            display: 'flex',
            width: '48%',
          }}
        >

          <div
            style={{
              width: '48%',
              borderRadius: '40px',
              padding: '20px',
              marginLeft: '6px',
              marginTop: '5px'
              
            }}
          >
            <SalesData />
          </div>


          <div
            style={{
              width: '80%',
              borderRadius: '40px',
              padding: '20px',
              marginTop: "8px",
              marginLeft:'60px'
              
            }}
          >
            <MostSoldProducts />
          </div>
        </div>
      </div>

      {/* Maintenance Message */}
      <div
        style={{
          position: 'absolute',
          top: '12%',
          left: '50%',
          width: '500px',
          transform: 'translate(-50%, -50%)',
          backgroundColor: '#FFFAE7',
          border: ' 1px solid #FFE586',
          color: "#DCAD00",
          padding: '5px',
          borderRadius: '10px',
          textAlign: 'center',
          fontSize: '14px',
          fontWeight: 'bold',
        }}
      >
        This page is under maintenance and will be available soon.
      </div>
    </div>
  );
}

export default Dashboard;
